import { useEffect, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { AppProvider } from "./context/AppContext";

// Route-level code splitting: each page becomes its own chunk so the initial
// JS only carries what the first screen needs.
const Home = lazy(() => import("./pages/Home"));
const Section = lazy(() => import("./pages/Section"));
const Post = lazy(() => import("./pages/Post"));
const Contacto = lazy(() => import("./pages/Contacto"));

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, search]);
  return null;
}

function PageFallback() {
  return (
    <div className="grid min-h-screen place-items-center" aria-busy="true">
      <div className="h-9 w-9 animate-spin rounded-full border-2 border-cr-primary/30 border-t-cr-primary" />
    </div>
  );
}

// Routes wrapped in AnimatePresence so each page fades/slides on navigation.
// `location` + `key` per pathname let AnimatePresence run the exit animation of
// the outgoing page before mounting the next one. mode="wait" avoids both pages
// overlapping mid-transition.
function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Suspense fallback={<PageFallback />}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/seccion/:key" element={<Section />} />
          <Route path="/post/:slug" element={<Post />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Suspense>
    </AnimatePresence>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AnimatedRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
